import type { AuthType, ValidateOtpType } from "@/domain";
import type { FidexaModulesType } from "@/utils/moduleTemplateUtils";
import type { UseMutateFunction } from "@tanstack/react-query";
import { createContext, useContext } from "react";

export type AuthContextType = {
  login: UseMutateFunction<void, Error, AuthType, unknown>;
  loginWithOtp: UseMutateFunction<void, Error, ValidateOtpType, unknown>;
  logout: UseMutateFunction<void, Error, void, unknown>;
  isLoading: boolean;
  isOtpLoading: boolean;
  accessToken: string | null;
  fidexaModules: FidexaModulesType[];
  featuresLoaded: boolean;
};

export const AuthContext = createContext<AuthContextType>(
  {} as AuthContextType
);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
